import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/david/Workspace/repos/analytics/site/main/.cache/caches/gatsby-mdx/mdx-scopes-dir/1970366a8c100bb8e42caab4bfa24659.js').default;

var scope_1 = require('/Users/david/Workspace/repos/analytics/site/main/.cache/caches/gatsby-mdx/mdx-scopes-dir/c1aaf9b88bf92c32857dd76adef5f7df.js').default;

var scope_2 = require('/Users/david/Workspace/repos/analytics/site/main/.cache/caches/gatsby-mdx/mdx-scopes-dir/f2b3370542886f0b5f90742ba2ab81a6.js').default;

export default Object.assign({}, scope_0, scope_1, scope_2);